import type { User } from "@dndbeyond/auth/types/user";
import type { Platform } from "@dndbeyond/event-pipeline-lib/shared";
import { sendEvent } from "./sendEvent";

export const instrumentDiceContainerOpen = async (
  user: User,
  platform: Platform,
  location: string,
  gameId?: number,
  playSessionId?: string,
  env?: string,
) => {
  try {
    await sendEvent(
      user,
      "GAME_ACTION",
      {
        gameId,
        playSessionId,
        actionTaken: "dice_container_open",
        actionDescriptors: [
          {
            location,
          },
        ],
      },
      platform,
      undefined,
      env,
    );
  } catch (error) {
    const message = error instanceof Error ? error.message : String(error);

    console.warn(message, {
      exception: error,
      location: `${platform} > ${location} > instrumentDiceContainerOpen`,
    });
  }
};
